/**
 * Sizes are ordered normally (S, M, L, XL…) but no size is pre-selected on
 * page load, so shoppers don't accidentally order whichever size happened to
 * be first. If someone tries to add to cart without picking one, scroll the
 * size picker into view and flag it instead of silently failing.
 */
(function () {
  // Form ids for which the shopper has genuinely clicked a size themselves.
  var explicitSizeFormIds = {};
  // Set the instant a size is clicked, consumed by the next variantChange
  // pass so we know to scroll to Add to Cart (and not, say, on a color pick).
  var lastExplicitFormId = null;

  function sizeFieldsetsForForm(formId) {
    var inputs = document.querySelectorAll(
      '[data-is-size-option] input[form="' +
        formId +
        '"], [data-is-size-option] select[form="' +
        formId +
        '"]',
    );
    var fieldsets = [];
    inputs.forEach(function (el) {
      var fieldset = el.closest("[data-is-size-option]");
      if (fieldset && fieldsets.indexOf(fieldset) === -1) {
        fieldsets.push(fieldset);
      }
    });
    return fieldsets;
  }

  function isSizeChosen(fieldset) {
    if (fieldset.querySelector('input[type="radio"]:checked')) return true;
    var select = fieldset.querySelector("select");
    if (select && select.value) return true;
    return false;
  }

  function clearWarning(fieldset) {
    fieldset.classList.remove("size-selector--warning");
    var message = fieldset.querySelector(".size-selector-warning-message");
    if (message) message.hidden = true;
  }

  function showWarning(fieldset) {
    fieldset.classList.remove("size-selector--warning");
    // Force reflow so the shake animation replays if it's already been shown once.
    void fieldset.offsetWidth;
    fieldset.classList.add("size-selector--warning");

    var message = fieldset.querySelector(".size-selector-warning-message");
    if (!message) {
      message = document.createElement("p");
      message.className = "size-selector-warning-message";
      message.setAttribute("role", "alert");
      message.textContent = "Select your size before adding to cart";
      fieldset.appendChild(message);
    }
    message.hidden = false;

    fieldset.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function formIdForFieldset(fieldset) {
    var input = fieldset.querySelector("input[form], select[form]");
    return input ? input.getAttribute("form") : null;
  }

  // Once a size is picked, the shopper is done deciding — bring the Add to
  // Cart button to them instead of leaving them to scroll back down past the
  // product photo the theme's own gallery-sync scroll just brought into view.
  function scrollToAddToCart(formId) {
    var form = document.getElementById(formId);
    var button = form && form.querySelector('button[type="submit"]');
    if (button) button.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  // Undo whatever default Shopify's own variant resolution just picked for
  // Size, unless this form's shopper has genuinely chosen a size themselves.
  // Has to re-run after every section re-render (not just once on page
  // load): picking a Color alone re-renders this fieldset from scratch, and
  // since Size isn't part of that request's option_values, Shopify falls
  // back to a default for it — un-blanking the picker if left alone.
  function resetIfNotExplicit(fieldset) {
    var formId = formIdForFieldset(fieldset);
    if (formId && explicitSizeFormIds[formId]) return;

    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) checked.checked = false;

    var select = fieldset.querySelector("select");
    if (select) select.value = "";

    var label = fieldset.querySelector(".form-label span");
    if (label) label.textContent = "";
  }

  function resetAllFieldsets() {
    document
      .querySelectorAll("[data-is-size-option]")
      .forEach(resetIfNotExplicit);
  }

  document.addEventListener("DOMContentLoaded", function () {
    resetAllFieldsets();

    if (typeof webvista !== "undefined" && webvista.subscribe) {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, function () {
        resetAllFieldsets();
        if (lastExplicitFormId) {
          var formId = lastExplicitFormId;
          lastExplicitFormId = null;
          scrollToAddToCart(formId);
        }
      });
    }
  });

  // Delegated on document (rather than attached per-fieldset) so this keeps
  // working after a section re-render swaps the fieldset for a fresh one.
  document.addEventListener("change", function (event) {
    var fieldset = event.target.closest("[data-is-size-option]");
    if (!fieldset) return;

    var formId = formIdForFieldset(fieldset);
    if (formId) {
      explicitSizeFormIds[formId] = true;
      lastExplicitFormId = formId;
    }
    clearWarning(fieldset);
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.dataset.type !== "add-to-cart-form") return;

      var invalidFieldset = sizeFieldsetsForForm(
        form.getAttribute("id"),
      ).find(function (fieldset) {
        return !isSizeChosen(fieldset);
      });
      if (!invalidFieldset) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showWarning(invalidFieldset);
    },
    true,
  );
})();
